import { IAction } from "coral-utility";
import { User } from "types";

export interface ConnectState {
  authenticated: boolean;
  user?: User;
  theme: Theme;
}

export const connectActionTypes = {
  USER_AUTHENTICATION_SUCCESS: "USER_AUTHENTICATION_SUCCESS",
  USER_AUTHENTICATION_FAILURE: "USER_AUTHENTICATION_FAILURE",
  TOGGLE_THEME: "TOGGLE_THEME",
  USER_LOGOUT_STARTED: "USER_LOGOUT_STARTED",
  USER_LOGOUT_SUCCESS: "USER_LOGOUT_SUCCESS",
};

type Theme = "light" | "dark";

export interface UserPayload {
  user: User;
}

export interface AuthenticatedSuccessPayload extends IAction {
  payload: UserPayload;
}

export type ConnectActionTypes = IAction | AuthenticatedSuccessPayload;
